// lib
import React from 'react';
// styles
import styles from './RecentlyAddedTag.module.scss';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
function RecentlyAddedTag() {
    return (React.createElement(Text, { className: styles.badge, variant: DlsFontVariants.discount_Subheader_S2, color: DlsColorTokens.text_inverse_Highest_Emphasis }, "Recently Added"));
}
export default RecentlyAddedTag;
